export function Attention()  {
    return (
        <span style={{color: "red", fontWeight: "700"}}>*</span>
    )
}
